<template>
<div :style="{'--themecolor':themecolors}">
    <div class="intro" id="scroll"  v-if="!loading">
        <div style="min-height:95%;">
            <div class="top">
                <div class="flex-center between info" style="width: 100%;">
                    <div class="avatar flex-center" @click="imagePreview(attendIntro.avatar_url)">
                        <img :src="attendIntro.avatar_url" alt="">
                    </div>
                    <div class="user-info">
                        <div class="user-name">
                            <img src="@/assets/attend/name-icon.svg" alt="">
                            <span>{{attendIntro.name}}</span>
                        </div>
                        <div class="user-hospital">
                            <img src="@/assets/attend/unit.svg" alt="">
                            <span>{{attendIntro.hospital}}</span>
                        </div>
                    </div>
                </div>
                <div class="introduction">
                    <van-collapse v-model="activeNames"  v-if="attendIntro.introduction!=null">
                        <van-collapse-item title="嘉宾简介" name="1">
                            <p class="intro_p" v-html="attendIntro.introduction">
                            </p>
                        </van-collapse-item>
                    </van-collapse>
                    <div class="null-info" v-else @click="nullInfo">
                        <span>嘉宾简介</span>
                        <img src="@/assets/schedule/arrow-right.svg" alt="">
                    </div>
                </div>
                
            </div>
            <div v-if="assignment.length != 0">
                 <div class="particular"  v-for="(item,itemInd) in assignment" :key="itemInd">
                    <div class="date_title">
                        <div class="date_time">
                            <div class="title-right" style="display: inline; float: right; margin: 0 0 5px 4px;">
                                <span class="red" v-if="item.red"></span>
                                <span class="meet-num">{{item.list.length}}</span>
                            </div>
                            <span class="schedule-title">{{ item.title_format }}</span>
                        </div>
                    </div>
                     <div class="data-content">
                        <div class="date_main" v-for="(i,index) in item.list" :key="index"  @click.stop="goRoom(i,item.title_format)">
                            <div style="flex:1">
                                 <div class="date_main_title">{{i.venue_title}}</div>
                                <div class="date_main_center"><van-icon name="clock-o" color="#4E5969" />{{i.start_time_format}}-{{i.end_time_format}}</div>
                                <div class="date_main_center" v-if="i.venue_position"><van-icon name="location-o" color="#4E5969" />{{i.venue_position}}</div>
                                <div class="date_main_center"><van-icon name="manager-o" color="#4E5969" />{{i.people_type==1?i.venue_guest:i.venue_host}}</div>
                            </div>
                            <div class="date_main_arrow"><van-icon name="arrow" /></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no-schedule" v-if="assignment.length == 0">
                <div class="title">
                    <span>暂无日程</span>
                    <div class="schedule-num">0</div>
                </div>
                <div class="no-img">
                    <img src="@/assets/attend/none-img.svg" alt="">
                    <div class="backtrack" @click.stop="goback">
                        返回
                    </div>
                </div>
            </div>
        </div>
        <Support></Support>
    </div>
     <van-loading :color="themecolors" :text-color="themecolors" v-else/>
</div>
</template>

<script>
import Support from '@/components/support';
import { ImagePreview } from "vant"; // 引入Vant图片预览组件
import { mapState } from 'vuex'
export default {
    components:{
        Support,
    },
    data() {
        return{
            attendIntro:{},
            showTask: false,
            showIntro: false,
            showOne: true,
            showTwo: true,
            activeNames:['1'],
            active: [],
            assignment: [],
            placeCconfig:[],
            params:{},
            showAttention:false,
            loading:true
        }
    },
    props:{
        app:Object,
    },
    created(){
        let obj = {
            module_id: this.app.random_number,
            page_id: this.app.page_id,
            site_id: this.site_id,
        }
        this.params = obj;
        this.attendIntro = JSON.parse(window.sessionStorage.getItem("attendIntro"));
        // this.getAcademicTasks()
        this.get_academic_assignments()
        if(sessionStorage.getItem('user_header') == 1 && this.$cookies.isKey('microtoken')){
            this.showAttention = true
        }else{
            this.showAttention = false
        }
    },
    computed: {
        ...mapState(['themecolors',"site_id"])
    },
    methods:{
        // 获取会场信息
        get_academic_assignments(){
            this.$store.dispatch('get_academic_assignments', {
                page_id: this.site_id,
                people_id: this.$cookies.get('people_id')
            }).then(res=>{
                if(res.data.code==200){
                    let tempArr = [];
                    Object.values(res.data.data).forEach(item=>{
                       if (tempArr.indexOf(item.id) === -1) {
                            this.assignment.push({
                                id: item.id,
                                title_format:item.title_format,
                                list: [item]
                            });
                            tempArr.push(item.id);
                       }else{
                          this.assignment.forEach(j=>{
                            if(j.id==item.id){
                                j.list.push(item)
                            }
                          })
                       }
                    })
                    this.loading=false
               }
            })
        },
        // 跳转
        goRoom(item,title){
            
             window.sessionStorage.setItem("scheduleTimelineCurrentItem",JSON.stringify(item))
            let obj = {
                component: "ScheduleInfo",
                hide: false,
                height: 700,
                width: 420,
                key: 'demo_scheduleInfo',
                module_title:title,
                reload:true,
                pid: new Date().valueOf() + "." + parseInt(Math.random() * 99999999),
                data: {
                    id: item.venue_id,
                    ...this.params,
                }
            }
            this.$store.commit("openApp", obj);
        },
        // 转日期格式
        timestampToTime (time) {
            // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let date = new Date(time * 1000) 
            let y = date.getFullYear()
            let MM = date.getMonth() + 1
            MM = MM < 10 ? ('0' + MM) : MM
            let d = date.getDate()
            d = d < 10 ? ('0' + d) : d
            let h = date.getHours()
            h = h < 10 ? ('0' + h) : h
            let m = date.getMinutes()
            m = m < 10 ? ('0' + m) : m
            let s = date.getSeconds()
            s = s < 10 ? ('0' + s) : s
            return MM + '-' + d
        },
        // 转星期格式前
        timestampToweek (time) {
            // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let date = new Date(time * 1000) 
            let y = date.getFullYear()
            let MM = date.getMonth() + 1
            MM = MM < 10 ? ('0' + MM) : MM
            let d = date.getDate()
            d = d < 10 ? ('0' + d) : d
            let h = date.getHours()
            h = h < 10 ? ('0' + h) : h
            let m = date.getMinutes()
            m = m < 10 ? ('0' + m) : m
            let s = date.getSeconds()
            s = s < 10 ? ('0' + s) : s
            return y + '-' + MM + '-' + d
        },
        // 转换日期为星期
        getWeek(dateString) {
            let dateArray = dateString.split("-");
            let date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
            return "周" + "日一二三四五六".charAt(date.getDay());
        },
        /** 时间段范围 */
        isDuringDate(beginDateStr, endDateStr) {
            var curDate = new Date(),
                beginDate = new Date(beginDateStr),
                endDate = new Date(endDateStr);
            if (curDate >= beginDate && curDate <= endDate) {
                return true;
            }
            return false;
        },
        imagePreview(img_url){
            let img = [];
            img.push(img_url)
            ImagePreview({
                images:img, //需要预览的图片 URL 数组 
                showIndex:false, //是否显示页码
                loop:false, //是否开启循环播放
                closeable: true,  // 显示关闭按钮
                startPosition:0, //图片预览起始位置索引
            });
        },
        //展开
        goback(){
            this.$router.go(-1)
        },
        unfold(index,val){
            if(index == 1){
                if(val == false){
                    this.showOne = false
                }else{
                    this.showOne = true
                }
            }else{
                if(val == false){
                    this.showTwo = false
                }else{
                    this.showTwo = true
                }
            }
        },
        nullInfo(){
            this.$toast('暂无嘉宾简介')
        }
    }
}
</script>

<style lang="less" scoped>
@Color:var(--themecolor);
.flex-center{
    display: flex;
    align-items: center;
}
.between{
    justify-content: space-between;
}
.intro{
    max-width: 420px;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    padding: 15px 15px 0 15px;
    background: #f2f6f8;
    overflow-y: scroll;
    .top{
        background: #fff;
        padding: 15px;
        border-radius: 6px;
        margin-bottom: 15px;
        background:url('../../../../assets/attend/info-line.svg') no-repeat top right,linear-gradient(#dde5ef 0%, #fff 100%);
        position: relative;
        p{
            font-size: 12px;
        }
        .info-line{
            position: absolute;
            top: 0px;
            right: 0px;
        }
        .info{
            z-index: 99;
            justify-content: flex-start;
        }
        .introduction{
            margin-top: 30px;
            border-top: 1px #D5D7E4 solid;
            /deep/.van-collapse{
                .van-collapse-item{
                    .van-cell{
                        background-color:rgba(0,0,0,0)!important;
                        padding: 15px 0 0;
                        .van-cell__title{
                            span{
                                color:#1F2129  ;
                                font-size: 14px;
                            }
                        }
                        .van-cell__right-icon{
                            color:#1F2129  ;
                            &::before{
                                transform: rotate(0deg);
                            }
                        }
                    }  
                    .van-collapse-item__wrapper{
                        .van-collapse-item__content{
                            background: none;
                            padding: 11px 0 2px;
                            p{
                                font-size: 14px;
                                color: #666;
                            }
                        }
                    }
                    .van-collapse-item__title--expanded{
                        .van-cell__right-icon{
                            color:#1F2129  ;
                            &::before{
                                transform: rotate(90deg);
                            }
                        }
                    } 
                }
            }
            .null-info{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top:15px;
                span{
                    color: #1F2129;
                    font-size: 14px;
                }
            }
        }
    }
    .top .avatar{
        width: 70px;
        height: 70px;
        border-radius: 60px;
        overflow: hidden;
        img{
            width: 100%;
            height: auto;
        }
    } 
    .top .user-info{
        line-height: 25px;
        max-width: 60%;
        margin-left:60px;
        .user-name{
            display: flex;
        }
        .user-hospital{
            display: flex;
            margin-top: 10px;
        }
        span{
            margin-left: 16px;
            font-size: 14px;
            display: block;
            width: 100%;
            font-size: 14px;
            color: #1F2129;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            // overflow: hidden;
            // font-family: 'PingFangBold';
        }
    }
    .no-schedule{
        background: #fff;
        border-radius: 10px;
        .title{
            display: flex;
            width: 100%;
            height: 44px;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
            border-bottom: 1px solid #F5F6FA;
            span{
                font-size: 18px;
                color: #1F2129;
                // font-family: 'PingFangBold';
            }
            .schedule-num{
                width: 20px;
                height: 20px;
                background: #F0F2FA;
                border-radius: 50%;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
            }
        }
        .no-img{
            width: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            img{
                margin-top: 60px;
                width: 213px;
                height: auto;
            }
            .backtrack{
                height: 50px;
                width: 213px;
                background:#F0F2FA ;
                color: #8F9DAF;
                font-size: 18px;
                border-radius: 25px;
                // font-family: 'PingFangBold';
                margin: 40px 0;
                display: flex;
                align-items: center;
                justify-content: center;

            }
        }
    }
    .bottom{
        border-radius: 6px;
        padding: 0 20px;
        background: #fff;
        position: relative;
        /deep/ .van-cell__title{
            span{
                font-size: 14px;
            }
        }
    }
    .bottom_margin{
        margin-top: 15px;
    }
    .particular{
        margin-top: 15px;
        border-radius: 8px;
        background-color: #fff;
        width: 100%;
        .date_title{
            width: 100%;

            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 17px;
            border-bottom:1px solid #F5F6FA;
            .date_time{
                flex: 1;
                color: #8F9DAF;
                font-size: 10px;
                .schedule-title{
                    font-weight: 700;
                    font-size: 16px;
                    color: #1F2129;
                    // margin-right: 11px;
                    word-break: break-all;
                    // font-family: 'PingFangBold';
                }
            }
            .title-right{
                margin-left: auto;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                .red{
                    width: 06px;
                    height: 6px;
                    display: block;
                    background: #FF5C60;
                    border-radius: 100%;
                    position: absolute;
                    top: -5px;
                    right: -6px;
                }
                .meet-num{
                    width: 20px;
                    height: 20px;
                    border-radius: 100%;
                    background: @Color;
                    font-size:12px;
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }
        .data-content{
            padding-top: 16px;
            .date_main{
               display: flex;
               align-items: center;
                justify-content: space-between;
               padding: 16px;
               border-bottom:1px #F5F6FA solid;
               &:first-child{
                padding-top: 0;
               }
               &:last-child{
                border-bottom:none;
               }
                .date_main_title{
                    margin-bottom: 15px;
                    font-size: 14px;
                    color: #1D2129;
                }
                .date_main_center{
                    color:#4E5969;
                    font-size: 14px;
                    margin-bottom: 4px;
                }
                .van-icon{
                    font-size: 16px;
                    margin-right: 10px;
                }
                .date_main_arrow{
                     display: flex;
                    align-items: center;
                    .van-icon{
                        font-size: 18px;
                        font-weight: 700;
                        color: #999;
                    }
                }
            }
        }
    }
}
.van-collapse{
    padding: 0;
}
/deep/ .van-collapse-item{
    &::after{
        border: none;
    }
    padding: 0;
    .van-cell .van-cell--clickable .van-collapse-item__title{
        padding: 10px 0;
        &::after{
            display: none;
        }
    }
    .van-collapse-item__title--expanded::after{
        display: none;
    }
}
.van-hairline--top-bottom::after{
    border: none;
}
/deep/ .van-cell{
    padding: 10px 0;
}
.live-gif{
    width: 24px;
    height: auto;
}
/deep/.van-loading{
    position: absolute;
    top: 50%;
    left:50%;
    transform:translate(-50%,-50%);
}
</style>